import { useSEO } from "../lib/seo";

export default function Terms() {
  useSEO({ title: "Terms of Service", description: "BeforeExam Terms of Service" });
  return (
    <div className="container-x py-14 max-w-3xl" data-testid="terms-page">
      <h1 className="font-display text-4xl tracking-tighter">Terms of <span className="font-serif text-gradient-gold">Service</span></h1>
      <p className="text-sm text-muted-foreground mt-2">Last updated: February 2026</p>

      <div className="mt-8 space-y-6 text-sm leading-relaxed">
        <Section title="Agreement">
          By using BeforeExam you agree to these terms. If you don't agree, don't use the service.
        </Section>
        <Section title="Accounts">
          You're responsible for keeping your credentials secure. One person per account.
        </Section>
        <Section title="Payments & refunds">
          Subscription and one-time payments are processed by Stripe. We offer a 30-day money-back guarantee on all paid courses and plans — email refunds@beforeexam.com.
        </Section>
        <Section title="Acceptable use">
          Don't share content with non-paying users, scrape the site, or attempt to disrupt the service. We may suspend accounts that abuse the platform.
        </Section>
        <Section title="Intellectual property">
          All practice-test content is © BeforeExam Labs. You're licensed to use it for your personal exam preparation only.
        </Section>
        <Section title="No exam guarantee">
          We help you prepare. Whether you pass depends on the time you put in. Our money-back guarantee covers refunds, not exam fees paid to the certification body.
        </Section>
        <Section title="Liability">
          The service is provided "as is". To the maximum extent permitted by law, our liability is capped at the amount you paid to us in the prior 12 months.
        </Section>
        <Section title="Contact">
          legal@beforeexam.com.
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-lg">{title}</h2>
      <p className="mt-2 text-muted-foreground">{children}</p>
    </div>
  );
}
